import { makeStyles } from '@material-ui/core/styles';

const useConferenceWrapperStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    width: '100vw',
    height: '100vh',
    overflow: 'hidden',
    justifyContent: 'flex-end',
  },
  showCaptions: {
    color: theme.palette.primary.main,
  },
  videoSection: {
    flexGrow: 1,
    height: '100vh',
  },
  sideMenu: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.down('mobile')]: {
      //height: '100vh',
      position: 'absolute',
      padding: '0.3rem',
      zIndex: 100,
    },
    [theme.breakpoints.up('mobile')]: {
      minHeight: '100vh',
      backgroundColor: theme.palette.background.dark,
      boxShadow: '-2px 0px 4px #0008',
      maxWidth: '7.5rem',
      minWidth: '7.5rem',
    },
  },
  sidePanel: {
    padding: 0,
    margin: 0,
    // border: '1px solid lightgrey',
    display: 'flex',
    flexDirection: 'column',
    backgroundImage: 'linear-gradient(to top right, #166B8B, #2A2A2A)',
    height: '100vh',
    [theme.breakpoints.down('mobile')]: {
      position: 'absolute',
      top: 0,
      left: 0,
      maxWidth: '100vw',
      minWidth: '100vw',
      zIndex: 101,
    },
    [theme.breakpoints.up('mobile')]: {
      boxShadow: '-2px 0px 4px #0008',
      maxWidth: '25rem',
      minWidth: '25rem',
    },
  },
  sidePanelContent: {
    display: 'flex',
    flexDirection: 'column',
    height: `calc(100% - ${theme.sidePanel.titleHeight + theme.sidePanel.brandingHeight}rem)`,
    [theme.breakpoints.down('mobile')]: {
      height: '100%',
    },
  },
  bottomIconList: {
    backgroundColor: theme.palette.tertiary.main,
    width: '50%',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '2rem',
    ...theme.mixins.borderRadius(),
    ...theme.mixins.shadow(),
  },
  attendeeStatusBox: {
    [theme.breakpoints.up('mobile')]: {
      flexGrow: 1,
      marginTop: '3rem',
    },
  },
}));

export default useConferenceWrapperStyles;
